const EVENTS = {
  APPLICATION_IS_WORKING: 'applicationIsWorking',
  APPLICATION_WORK_FINISHED: 'applicationWorkFinished',
  APP_READY: 'appReady',
  TOAST_NOTIFICATION_REQUESTED: 'toastNotificationRequested',
  USER_DATA_AVAILABLE: 'userDataAvailable',
  RESTAURANT_DATA_AVAILABLE: 'restaurantDataAvailable',
  USER_CONNECTED: 'userConnected',
  LOGOUT_REQUESTED: 'logoutRequested',
  USER_DISCONNECTED: 'userDisconnected',
}

export { EVENTS }
